<template>
  <div>
    <breadcrumbs></breadcrumbs>
    <div v-if="this.ob == 2">
      <div class="ind-title lh50 f16">
        <!-- <i class="el-icon-loading"></i> -->
        账单详情
      </div>

      <div>
        <div class="getzahi-a" v-if="this.std == 0">待结算</div>

        <div class="getzahi-a" v-if="this.std == 1">已结算</div>
      </div>

      <div class="odd"></div>
      <div>总计物流成本：￥{{ this.cost }}</div>
      <el-divider></el-divider>

      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
      >
        <el-table-column label="序号" prop="index" type="index">
        </el-table-column>

        <el-table-column label="出库单号" prop="orderNo"> </el-table-column>

        <el-table-column label="发货回收站" prop="stopName"> </el-table-column>

        <el-table-column label="收货仓库" prop="houseName"> </el-table-column>

        <el-table-column label="仓库编号" prop="houseId"> </el-table-column>

        <el-table-column label="数量" prop="allCount"> </el-table-column>

        <el-table-column label="入库时间" prop="endTime"> </el-table-column>

        <el-table-column label="物流公司" prop="logisticsName">
        </el-table-column>

        <el-table-column label="物流单号" prop="logisticsNo"> </el-table-column>

        <el-table-column label="物流成本" prop="cost"> </el-table-column>

        <el-table-column label="凭证" prop="proof">
          
               <template slot-scope="scope">

             <img class="img-a"  :src="scope.row.proof" alt="">

           </template>  
          
          
          
           </el-table-column>


        

        <!-- <el-table-column label="操作" prop="name" width="180">
        <template>
    
          <el-link style="margin: 0 10px" type="primary"  >查看凭证</el-link>
         

        </template>
      </el-table-column> -->
      </el-table>

      <el-button
        v-if="this.checkState == 0"
        style="margin: 30px 10px"
        type="primary"
        @click="getshenhelist"
        >审核</el-button
      >
    </div>

    <div v-if="this.ob == 1">
      <div class="ind-title lh50 f16">
        <!-- <i class="el-icon-loading"></i> -->
        账单详情
      </div>

      <div>
        <div class="getzahi-a" v-if="this.std == 0">待结算</div>

        <div class="getzahi-a" v-if="this.std == 1">已结算</div>
      </div>

      <div class="odd"></div>
      <div>总计物流成本：￥{{ this.cost }}</div>
      <el-divider></el-divider>

      <el-table
        :data="tableData1"
        style="width: 100%"
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
      >
        <el-table-column label="序号" prop="index" type="index">
        </el-table-column>

        <el-table-column label="出库单号" prop="outOrderNo"> </el-table-column>

        <el-table-column label="发货仓库" prop="houseName"> </el-table-column>

        <el-table-column label="仓库编号" prop="houseId"> </el-table-column>

        <el-table-column label="品牌" prop="brandName"> </el-table-column>

        <el-table-column label="数量" prop="allCount"> </el-table-column>

        <el-table-column label="采购商" prop="shopName"> </el-table-column>

        <el-table-column label="出库时间" prop="outTime"> </el-table-column>

        <el-table-column label="物流公司" prop="logisticsName">
        </el-table-column>

        <el-table-column label="物流单号" prop="logisticsNo"> </el-table-column>

        <el-table-column label="物流成本" prop="cost"> </el-table-column>

        <el-table-column label="凭证" prop="proof"> 

           <template slot-scope="scope">

             <img class="img-a"  :src="scope.row.proof" alt="">

           </template>  


        </el-table-column>

        <!-- <el-table-column label="操作" prop="name" width="180">
        <template>
    
          <el-link style="margin: 0 10px" type="primary"  >查看凭证</el-link>
         

        </template>
      </el-table-column> -->
      </el-table>

      <el-button
        v-if="this.checkState == 0"
        style="margin: 30px 10px"
        @click="getshenhe"
        type="primary"
        >审核</el-button
      >
    </div>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      value1: "",
      tableData1: [],
      ob: this.$route.query.ob,
      std: this.$route.query.st,
      cost: this.$route.query.cost,
      checkState: this.$route.query.checkState,
      form: {
        name: "",
        region: "",
      },

      addORUpdateVisible: false,
      tableData: [],
      searchForm: {
        name: "",
      },
    };
  },

  created() {
    this.getInOrderCostDetail();

    this.getHouseOutOrderCostDetail();
  },

  methods: {
    getshenhe() {
      this.$confirm("此期账单无误，确认审核, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api.activitymsg
          .checkCost({
            billId: this.$route.query.id,
          })
          .then((d) => {
            if (d.code == 200) {
              this.$router.push("/managementhrough/index");
              this.$message({
                message: "审核成功",
                type: "warning",
              });
            } else {
              this.$message.error(d.msg);
            }
          });
        // console.log(this.tableSelection[0].enable);
      });
    },

    getshenhelist() {
      this.$confirm("此期账单无误，确认审核, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api.activitymsg
          .checkCost({
            billId: this.$route.query.id,
          })
          .then((d) => {
            if (d.code == 200) {
              this.$router.push("/managementhrough/chuku");
              this.$message({
                message: "审核成功",
                type: "warning",
              });
            } else {
              this.$message.error(d.msg);
            }
          });
        // console.log(this.tableSelection[0].enable);
      });
    },

    getHouseOutOrderCostDetail() {
      this.$api.activitymsg
        .getHouseOutOrderCostDetail({
          billId: this.$route.query.id,
        })
        .then((e) => {
          this.tableData1 = e.data;
          // this.totalCount = e.totalCount;
        });
    },

    getInOrderCostDetail() {
      this.$api.activitymsg
        .getInOrderCostDetail({
          billId: this.$route.query.id,
        })
        .then((e) => {
          this.tableData = e.data;
          // this.totalCount = e.totalCount;
        });
    },
  },
};
</script>

<style scoped>


 .img-a{
   width: 100px;
   height: 100px;
 }


.odd {
  height: 20px;
}

.getzahi-a {
  width: 120px;
  height: 50px;
  display: flex;
  border: solid 1px var(--input-border);
  justify-content: center;
  align-items: center;
}
</style>
